import React from "react";
import {observer} from "mobx-react";
import {MiniSafezoneBox} from "./boxes/mini-safezone.box";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {SAFEZONE_CONTAINERS_ID} from "../../../services/safezone/safezone.service.interface";

@observer
export class MiniSafezoneComponent extends OrbitComponent<{}> {

  render() {
    if (!this.services.safezone.isEnabled || this.services.safezone.hasError) {
      return null;
    }

    return (
      <MiniSafezoneBox
          id={SAFEZONE_CONTAINERS_ID.MINI_SAFEZONE_CONTAINER_ID}
          className={"cy-mini-safezone"}
      />
    );
  }
}
